// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".wrapper[data-v-65766a95]{width:100%}.slot-container[data-v-65766a95]{max-width:calc(100% - 56px)}.margin-right[data-v-65766a95]{margin-right:6px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
